<template>
  <b-card
    class="text-center"
    :style="customHeight ? { height: customHeight } : ''"
    :role="isButton ? 'button' : ''"
    @click="goToDashboard"
  >
    <b-avatar
      class="mb-1"
      :variant="iconVariant"
      size="45"
    >
      <feather-icon
        size="21"
        icon="UserCheckIcon"
      />
    </b-avatar>
    <div class="truncate">
      <h2 class="mb-25 font-weight-bolder">
        {{ statistic }}
      </h2>
      <span>{{ $t(i18nVariable) }}</span>
    </div>
  </b-card>
</template>

<script>
import { BCard, BAvatar } from 'bootstrap-vue'

export default {
  components: {
    BCard,
    BAvatar,
  },
  props: {
    statistic: {
      type: [Number, String],
      required: true,
    },
    customHeight: {
      type: String,
      default: '',
    },
    isButton: {
      type: Boolean,
      default: false,
    },
    i18nVariable: {
      type: String,
      default: 'label.adherence',
    },
    iconVariant: {
      type: String,
      default: 'light-success',
    },
  },
  setup(props, { emit }) {
    const goToDashboard = () => emit('goToDashboard')

    return {
      goToDashboard,
    }
  },
}
</script>
